import { Collapse } from "@mui/material";
import { User } from "certiblok-api-manager";
import { useFormContext } from "react-hook-form";
import { useMe } from "../../../../../utils/hooks/useMe";
import { useCompany } from "../../../../../utils/queries/globalQueries";
import { EditCreateFolderFormValues } from "../hooks/useEditCreateFolderZodSchema";
import MemberInFolder from "./MemberInFolder";
import { TransitionGroup } from "react-transition-group";

type FilteredUsersListProps = {
	filterValue: string;
	isParentRestricted: boolean;
	parentUsers?: User[];
};

export const FilteredUsersList = ({ filterValue, isParentRestricted, parentUsers }: FilteredUsersListProps) => {
	const { me } = useMe();
	const { data: companyData } = useCompany();
	const { watch, setValue } = useFormContext<EditCreateFolderFormValues>();
	const reservedToUsers = watch("reservedToUsers");

	const usersToShow = isParentRestricted
		? (parentUsers ?? []).filter((user) =>
				`${user.name}${user.surname}`.toLowerCase().includes(filterValue.toLowerCase().replaceAll(" ", ""))
		  )
		: reservedToUsers;

	return (
		<TransitionGroup>
			{usersToShow.map((user) => {
				if (user.isNew) {
					return null;
				}
				const isExcludedFromParent = isParentRestricted && reservedToUsers.findIndex((u) => u.id === user.id) === -1;
				return user._id === me?.id || user._id === companyData?.data.ownerId ? null : (
					<Collapse key={user._id}>
						<MemberInFolder
							user={user}
							endIcon={isParentRestricted ? "eye" : "delete"}
							onEndIconClick={() => {
								if (!isExcludedFromParent || !isParentRestricted) {
									setValue(
										"reservedToUsers",
										reservedToUsers.filter((selectedUsers) => selectedUsers.id !== user.id)
									);
								} else {
									setValue("reservedToUsers", [...reservedToUsers, user]);
								}
							}}
							sx={{
								marginTop: 1,
							}}
							excludedFromParent={isExcludedFromParent}
						/>
					</Collapse>
				);
			})}
		</TransitionGroup>
	);
};
